exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Steps-module__wrapper___2JiRp{width:40px;height:40px}.Steps-module__wrapper___2JiRp button img{height:100%}@media screen and (min-height:500px){.Steps-module__wrapper___2JiRp{position:relative}}.Steps-module__wrapper___2JiRp .Steps-module__inner-wrapper___Xx6Ue{display:grid;gap:1em;grid-template-columns:230px;grid-template-rows:repeat(5,70px)}", ""]);

// exports
exports.locals = {
	"wrapper": "Steps-module__wrapper___2JiRp",
	"inner-wrapper": "Steps-module__inner-wrapper___Xx6Ue"
};